import '@fontsource-variable/inter';
import { z } from 'zod';

import { FontSizesStruct, FontWeightsStruct } from './types';

export const fontFamily = [
  // Preferred Finley font
  'Inter Variable',
  // Mac system fonts
  '-apple-system',
  'BlinkMacSystemFont',
  // Windows system fonts
  'Segoe UI',
  // Common fallback fonts
  'Helvetica',
  'Arial',
  // All else failed, hopefully user has at least one sans-serif font installed in their OS
  'sans-serif',
  // Emoji fonts
  'Apple Color Emoji',
  'Segoe UI Emoji',
  'Segoe UI Symbol',
].join(',');

export const fontSizes = {
  xs: { fontSize: '0.75rem', lineHeight: '1.125rem' },
  sm: { fontSize: '0.875rem', lineHeight: '1.3125rem' },
  base: { fontSize: '1rem', lineHeight: '1.5rem' },
  lg: { fontSize: '1.125rem', lineHeight: '1.4375rem' },
  xl: { fontSize: '1.25rem', lineHeight: '1.625rem' },
  '2xl': { fontSize: '1.5rem', lineHeight: '1.9375rem' },
  '3xl': { fontSize: '1.875rem', lineHeight: '2.25rem' },
  '4xl': { fontSize: '2.25rem', lineHeight: '2.6875rem' },
  '5xl': { fontSize: '3rem', lineHeight: '3.5625rem' },
} as const;
// Asserts that we only use design system font sizes above. This is preferable to a type cast to
// `Record<FontSizes, ...>` because we preserve the inferred string literal values for `fontSize`
// and `lineHeight` (e.g. You can hover over `fontSizes['2xl'].fontSize` and see the `1.5rem`).
// !TODO @typescript5 refactor to `satisfies`
z.array(FontSizesStruct).parse(Object.keys(fontSizes));

export const fontWeights = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;
// Asserts that we only use design system font weight above. This is preferable to a type cast to
// `Record<FontWeights, ...>` because we preserve the inferred string literal values for `fontWeight`
// (e.g. You can hover over `fontWeights.normal` and see the `400`).
// !TODO @typescript5 refactor to `satisfies`
z.array(FontWeightsStruct).parse(Object.keys(fontWeights));
